import {
    TestElementSequenceType
} from '../Enums';
import Environment from '../Environment';

export default class OrientationInstructionPlayer {
    /**
     * OrientationInstructionPlayer constructor
     * @param {Environment} environment
     */
    constructor(environment) {
        this.environment = environment;

        this.position = null;
        this.isActive = false;
        this.testArticleElement = document.getElementById('test');
        this.connectingToMediaServerElement = document.getElementById('connecting-media-server')
        this.orientationInstructionElement = null;
        this.orientationText = null;
        this.updatePositionInterval = null;
    }

    start(element) {
        if (this.environment.isMobile) {
            this.orientationText = element.width > element.height ? 'landscape' : 'portrait';
            const screenOrientationText = window.matchMedia("(orientation: landscape)").matches ? 'landscape' : 'portrait';

            if (this.orientationText !== screenOrientationText) {
                this.position = 0;
                this.updatePositionInterval = setInterval(() => this.position += 100, 100);
                this.testArticleElement.classList.remove('active');
                this.connectingToMediaServerElement.classList.remove('active');
                this.orientationInstructionElement = document.getElementById(this.orientationText + '_orientation_instruction');
                this.orientationInstructionElement.classList.add('visible');
                this.isActive = true;
            }
        }
    }

    stop() {
        this.testArticleElement.classList.add('active');
        this.orientationInstructionElement.classList.remove('visible');
        this.isActive = false;
        clearInterval(this.updatePositionInterval);
    }

    getPosition() {
        return {
            elementId: -1,
            elementType: TestElementSequenceType.OrientationInstruction,
            externalInfo: this.orientationText,
            position: this.position
        };
    }

    onStateChange() {
        //This needs just for interface compatibility
    }
}
